export const isBrowser = () => typeof window !== 'undefined'

/**
 * True on a page Salesforce Commerce Cloud renders itself (the legacy webstore
 * PDP), which sets `window.platform.isWebstore`. No monorepo host ever calls
 * `initializeAnalytics` there, so a widget mounted on it has to own the page:
 * registered as composed, it waits for a host forever and its events never send.
 *
 * Headless (`isHeadless`) and Shopify (`isShopify`) are monorepo hosts and
 * return false.
 */
export const isSfccHostedPage = (): boolean =>
  isBrowser() &&
  (window as { platform?: { isWebstore?: boolean } }).platform?.isWebstore ===
    true
